<template>
    <div v-if="showInfoModal">
        <b-modal v-model="showInfoModal" :content-class="'custom-modal suggests-modal'">
            <template v-slot:modal-header="{ close }">
                <span class="close-icon" @click="cancel"></span>
            </template>

            <div class="modal-icon" :style="backgroundImage"></div>
            <h2 class="modal-title">{{ translate('SearchForQuestion') }}</h2>

            <div class="suggests-search">

                <div class="search">
                    <div class="img">
                        <img src="@/assets/images/ic_search.png">
                    </div>
                    <div class="input">
                        <input type="text"
                               v-model="search"
                               :placeholder="translate('SearchForQuestion')">
                    </div>
                </div>

                <div class="results">

                    <template
                            v-for="group in filterGroups()"

                    >
                        <div class="result-group">
                            <label>{{group.name}}</label>
                            <ul>
                                <li v-for="item in group.items"
                                    :class="{'active': item == selected}"
                                    @click="selectItem(item)"
                                >
                                    {{item.text}}
                                </li>
                            </ul>
                        </div>
                    </template>

                </div>

            </div>

            <template v-slot:modal-footer>
                <button class="primaryButton clear" @click="cancel">
                    <template>{{ translate('Cancel') }}</template>
                </button>

                <button class="primaryButton"
                        :class="{disabled: !selected}"
                        @click="save"
                        :disabled="!selected ? true : false"
                >
                    <template>{{translate('UseQuestion')}}</template>
                </button>

            </template>

        </b-modal>
    </div>
</template>

<script>
    import _ from "lodash";
    import errorMixin from '@/mixins/errorMixin';
    import {mapActions} from 'vuex';

    export default {
        name: 'customModalDialog',

        mixins: [errorMixin],

        data() {
            return {
                showInfoModal: !_.isEmpty(this.settings),
                backgroundImage: 'background-image: url(' + require(`@/assets/icons/suggestsTitle.svg`) + ')',
                selected: null,
                search: '',
                suggests: {
                    groups: []
                }
            }
        },

        watch: {
            settings(newValue) {
                this.showInfoModal = !_.isEmpty(newValue)
            },
            search(newValue) {
                this.filterGroups()
            },
            showInfoModal(newValue) {
                if (newValue) {
                    this.reloadData()
                }
            }
        },

        props: {
            settings: {
                type: [Object, null],
                default: () => {
                    return {}
                }
            },
        },

        methods: {
            ...mapActions({
                fetchQuestionSuggestions: 'question/fetchQuestionSuggestions'
            }),

            async reloadData() {
                try {
                    const response = await this.fetchQuestionSuggestions()
                    if (response.success) {
                        this.suggests.groups = response.templates
                        this.suggests.groups.unshift({
                            text: this.translate('question_suggestions_freq_title'),
                            items: response.top.map(str => {
                                return {text: str}
                            })
                        })
                    } else {
                        //todo show error?
                    }
                } catch (e) {
                    console.log('error', e)
                    //todo show error?
                } finally {

                }
            },

            filterGroups() {
                var result = []
                this.suggests.groups.forEach(group => {
                    if (group.text.toLowerCase().includes(this.search.toLowerCase())
                        || this.search.toLowerCase().includes(group.text.toLowerCase())) {
                        result.push({
                            name: group.text,
                            items: group.items
                        })
                    } else {
                        var items = group.items.filter(item => {
                            return item.text.toLowerCase().includes(this.search.toLowerCase()) || this.search.toLowerCase().includes(item.text.toLowerCase())
                        })
                        if (items.length != 0) {
                            result.push({
                                name: group.text,
                                items: items
                            })
                        }
                    }
                })
                return result
            },

            selectItem(item) {

                if (this.selected == item) {
                    this.selected = null
                } else {
                    this.selected = item
                }

            },

            async cancel() {
                this.showInfoModal = false
                this.clearFields()
                if (this.settings.onCancelHandler) {
                    await this.settings.onCancelHandler()
                }
            },

            async save() {
                this.showInfoModal = false
                if (this.settings.onOkHandler) {
                    try {
                        await this.settings.onOkHandler(this.selected.text)
                        this.clearFields()
                    } catch (error) {
                        this.showErrorModal(error.message)
                    }
                }
            },

            clearFields() {
                this.selected = null
                this.search = ''
            },

        },
    }
</script>

<style>

    .suggests-search {
        max-height: 394px;
        max-width: 473px;
        margin: 17px auto;
        margin-bottom: -15px;
        border: 1px solid #9E9E9E;
        border-radius: 4px;
        background-color: rgba(0, 0, 0, 0.02);
    }


    .suggests-search .search {
        min-height: 64px;
        border-radius: 4px;
        background-color: #F7F7F7;
        padding: 20px 16px;
        display: flex;
        justify-content: space-between;
    }

    .suggests-search .search .input {
        position: relative;
        width: 100%;
        margin-left: 7px;
        text-align: left;
    }

    .suggests-search .search .input:after {
        position: absolute;
        content: '';
        right: 0;
        bottom: -5px;
        left: 0;
        height: 1px;
        background-color: #3F405C;
    }

    .suggests-search .search .input input::placeholder {
        color: #2F2F2F;
    }

    .suggests-search .search .input input {
        border: 0;
        outline: none;
        background: none;
    }

    /*result*/

    .suggests-search .results {
        overflow-y: scroll;
        height: 250px;
    }

    @media screen and (max-width: 425px) {
        .suggests-search .results {
            overflow-y: scroll;
            height: 150px;
        }
    }

    .suggests-search .results .result-group {
        padding: 8px 0;
    }

    .suggests-search .results .result-group label {
        color: #9E9E9E;
        display: block;
        font-size: 10px;
        font-weight: bold;
        letter-spacing: 0.5px;
        line-height: 22px;
        text-align: left;
        max-width: 473px;
        text-transform: uppercase;
        margin: 0 25px;
    }

    .suggests-search .results .result-group ul {
        margin: 0;
        position: relative;
        padding-bottom: 9px;
    }

    .suggests-search .results .result-group ul li {
        color: #2F2F2F;
        font-size: 14px;
        letter-spacing: 0;
        line-height: 22px;
        width: 100%;
        text-align: left;
        margin: 0;
        padding: 5px 25px;
        cursor: pointer;
        transition: all .15s ease-in-out;
    }

    .suggests-search .results .result-group ul li.active,
    .suggests-search .results .result-group ul li:hover {
        background-color: #1976D2;
        color: #fff;
    }

    .suggests-search .results .result-group:not(:last-child) ul:after {
        position: absolute;
        content: '';
        right: 25px;
        bottom: 0;
        left: 25px;
        height: 1px;
        background-color: #9E9E9E;
    }

</style>

<style>

    .modal-secondary-text {
        font-size: 12px;
        font-weight: 700;
        margin-top: 15px;
    }

    .custom-modal .close-icon {
        position: static;
        cursor: pointer;
        width: 28px;
        height: 28px;
        background: url('../../assets/icons/ic_close_white.svg') 50% no-repeat;
    }

    .custom-modal .modal-title {
        font-size: 16px;
        line-height: 24px;
        font-weight: bold;
        color: #2F2F2F;
        text-align: center;
    }

    .custom-modal .modal-header {
        text-align: center;
        border: none;
        justify-content: flex-end;
        padding-bottom: 0;
    }

    .custom-modal .modal-footer a {
        text-decoration: none;
    }

    .custom-modal.suggests-modal .modal-footer {
        border: none;
        justify-content: space-between;
    }

    .custom-modal.suggests-modal .modal-footer .primaryButton {
        min-width: 210px;
    }

    .custom-modal .modal-message {
        font-size: 14px;
        line-height: 22px;
        color: #2F2F2F;
        max-width: 360px;
        margin: 15px auto 0;
    }

    .custom-modal {
        text-align: center;
    }

    .modal-input {
        margin-top: 15px;
    }

    .modal-input input:focus {
        border-color: #2F2F2F;
        box-shadow: 0 0 0 0.2rem rgba(47, 47, 47, 0.25);
    }

    .custom-modal .modal-icon {
        width: 56px;
        height: 56px;
        margin: 0 auto;
        background-size: cover;
        margin-bottom: 15px;
    }

</style>
